import { z } from "zod";

export const getContactMemberSchema = z.object({
	contactMemberId: z.string().nonempty(),
	contactId: z.string().default("unknown"),
});

export type GetContactMemberSchema = z.infer<typeof getContactMemberSchema>;
